import React, { useState } from 'react';
import { X, ArrowRight, ArrowLeft, RefreshCw, Wrench, Gift, Package } from 'lucide-react';
import api from '../../services/api';
import { useObras } from './useEstoqueConfig';

const TIPOS = [
  { value: 'retirada',           label: 'Retirar para obra',      icon: ArrowRight, color: 'text-blue-600' },
  { value: 'devolucao',          label: 'Devolver ao escritório',  icon: ArrowLeft,  color: 'text-green-600' },
  { value: 'transferencia',      label: 'Transferir entre obras',  icon: RefreshCw,  color: 'text-indigo-600' },
  { value: 'manutencao_entrada', label: 'Enviar para manutenção',  icon: Wrench,     color: 'text-yellow-600' },
  { value: 'manutencao_saida',   label: 'Retornar da manutenção',  icon: Wrench,     color: 'text-teal-600' },
  { value: 'emprestimo',         label: 'Registrar empréstimo',    icon: Gift,       color: 'text-purple-600' },
];

export default function EstoqueMovimentarModal({ item, onClose, onSuccess }) {
  const obras = useObras();
  const [tipo, setTipo] = useState('retirada');
  const [obra_destino, setObraDestino] = useState('');
  const [responsavel, setResponsavel] = useState('');
  const [observacao, setObservacao] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const precisaObra = ['retirada', 'transferencia', 'manutencao_saida', 'emprestimo'].includes(tipo);

  async function salvar() {
    if (!responsavel.trim()) { setErro('Informe o responsável'); return; }
    if (precisaObra && !obra_destino) { setErro('Selecione a obra destino'); return; }
    setLoading(true); setErro('');
    try {
      await api.post(`/estoque/itens/${item.id}/movimentar`, { tipo, obra_destino, responsavel, observacao });
      onSuccess?.();
      onClose();
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao movimentar');
    } finally { setLoading(false); }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-5 border-b">
          <div>
            <h2 className="text-lg font-bold text-gray-800">Movimentar Item</h2>
            <p className="text-sm text-gray-500">{item.codigo} — {item.nome}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-1 rounded-lg">
            <X size={20} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de movimentação</label>
            <div className="grid grid-cols-2 gap-2">
              {TIPOS.map(t => {
                const Icon = t.icon;
                return (
                  <button
                    key={t.value}
                    onClick={() => setTipo(t.value)}
                    className={`flex items-center gap-2 p-3 rounded-xl border-2 text-sm font-medium transition-colors ${
                      tipo === t.value ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <Icon size={16} className={t.color} />
                    {t.label}
                  </button>
                );
              })}
            </div>
          </div>

          {precisaObra && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Obra destino *</label>
              <select value={obra_destino} onChange={e => setObraDestino(e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                <option value="">Selecione...</option>
                {obras.map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Responsável *</label>
            <input value={responsavel} onChange={e => setResponsavel(e.target.value)} placeholder="Nome do responsável"
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400" />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Observação</label>
            <textarea value={observacao} onChange={e => setObservacao(e.target.value)} rows={2} placeholder="Observação opcional..."
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400" />
          </div>

          {erro && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{erro}</p>}
        </div>

        <div className="flex gap-3 p-5 pt-0">
          <button onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 text-gray-700 rounded-xl text-sm font-medium hover:bg-gray-50">
            Cancelar
          </button>
          <button onClick={salvar} disabled={loading}
            className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
            {loading ? 'Salvando...' : 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  );
}
